<div class="dialog-shell">
  <button type="button" (click)="close()" class="dialog-close" aria-label="close">✕</button>

  <div class="dialog-content p-6">
    @switch (contentType) {
      @case ('string') {
        <div [innerHTML]="content"></div>
      }
      @case ('template') {
        <ng-container *ngTemplateOutlet="content; context: context"></ng-container>
      }
      @case ('component') {
        <ng-container *ngComponentOutlet="content2"></ng-container>
      }
    }
  </div>
</div>
